module.exports = __webpack_public_path__ + "img/ico_account_owner.cc7e2abf.svg";